import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../layout/LayoutContainer'
import { SIDE_BAR_SCROLL_ID } from '../../SideBarUserManagement'
import { InputDate } from '../common/InputDate'
import { REPORT_TYPES } from '../orderManagement/constants'
import { ALL_STATUS } from './constants'
import {
  changeFilter,
  selectFilterByKey,
  selectPackageTypeList,
} from './store/slice'
import { getFiinGateReportTypes } from './store/thunk'

export const FilterList = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getFiinGateReportTypes())
  }, [])

  return (
    <div
      className="dFlex flexWrap"
      style={{ padding: 12, paddingBottom: 0, gap: '12px 130px' }}
    >
      <PackageType />
      <PurchaseDate />
      <ExpiryDate />
    </div>
  )
}

const PackageType = () => {
  const dispatch = useDispatch()

  const packageTypesList = useSelector(selectPackageTypeList)
  const packageType = useSelector(selectFilterByKey('packageType'))

  const selectionPackageTypes = [
    ALL_STATUS,
    ...packageTypesList
      .filter(
        (item) =>
          ![
            REPORT_TYPES.INTERNATIONAL_REPORT,
            REPORT_TYPES.BUSINESS_CONCIERGE,
          ].includes(item.id),
      )
      .map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
        key: item.id,
      })),
  ]

  const changePackageType = (item) => {
    dispatch(changeFilter({ packageType: item }))
  }

  return (
    <div className="flexRow alignItemsCenter">
      <Element className="fw600">
        <Translate value="userManagement.availablePackage.PACKAGE_TYPE" />
      </Element>
      <SelectCustom
        data={selectionPackageTypes}
        chooseItem={changePackageType}
        style={{
          minWidth: 150,
          width: 'fit-content',
          color: '#3A414B',
          marginLeft: 10,
        }}
        isI18n
        activeItem={packageType}
        zIndex={14}
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}

const PurchaseDate = ({ appendStyleContainer }) => {
  const dispatch = useDispatch()

  const purchaseDate = useSelector(selectFilterByKey('purchaseDate'))
  const from = purchaseDate?.from
  const to = purchaseDate?.to

  const onFromChange = (val) => {
    dispatch(
      changeFilter({
        ...{ purchaseDate: { ...purchaseDate, from: val } },
        page: 1,
      }),
    )
  }

  const onToChange = (val) => {
    dispatch(
      changeFilter({
        ...{ purchaseDate: { ...purchaseDate, to: val } },
        page: 1,
      }),
    )
  }

  return (
    <div
      className="flexRow alignItemsCenter"
      style={{
        ...appendStyleContainer,
      }}
    >
      <Element className="fw600">
        <Translate value="userManagement.availablePackage.PURCHASE_DATE" />
      </Element>
      <div className="flexRow">
        <InputDate
          defaultDate={from ? from : undefined}
          value={from}
          onChange={onFromChange}
          placeholder={UseI18n('screening.FROM')}
        />
        <InputDate
          defaultDate={to ? to : undefined}
          value={to}
          onChange={onToChange}
          placeholder={UseI18n('screening.TO')}
        />
      </div>
    </div>
  )
}

const ExpiryDate = () => {
  const dispatch = useDispatch()

  const expiryDate = useSelector(selectFilterByKey('expiryDate'))
  const from = expiryDate?.from
  const to = expiryDate?.to

  const onFromChange = (val) => {
    dispatch(
      changeFilter({
        ...{ expiryDate: { ...expiryDate, from: val } },
        page: 1,
      }),
    )
  }

  const onToChange = (val) => {
    dispatch(
      changeFilter({ ...{ expiryDate: { ...expiryDate, to: val } }, page: 1 }),
    )
  }

  return (
    <div className="flexRow alignItemsCenter">
      <Element className="fw600">
        <Translate value="userManagement.availablePackage.EXPIRY_DATE" />
      </Element>
      <div className="flexRow">
        <InputDate
          defaultDate={from ? from : undefined}
          value={from}
          onChange={onFromChange}
          placeholder={UseI18n('screening.FROM')}
        />
        <InputDate
          defaultDate={to ? to : undefined}
          value={to}
          onChange={onToChange}
          placeholder={UseI18n('screening.TO')}
        />
      </div>
    </div>
  )
}
